import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo/Logo";
import "./CliSuccess.css";

export const CliSuccess: React.FC = () => {
  return (
    <div className="cli-success-page">
      <div className="cli-success-container">
        <Logo variant="dark" size="medium" />
        <h1 className="cli-success-heading">CLI Setup Complete!</h1>
        <p className="cli-success-message">
          Your FancyCloud CLI has been successfully configured and is ready to use.
        </p>
        <p className="cli-success-details">
          You can now manage your infrastructure directly from the command line.
          Documentation and usage examples will be available here soon.
        </p>
        <Link to="/" className="cli-success-button">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default CliSuccess;
